import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2196c14a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2196c14a')) {
      api.createRecord('2196c14a', component.options)
    } else {
      api.reload('2196c14a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2196c14a", function () {
      api.rerender('2196c14a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sfe/reportModule/orderDetail/index.vue"
export default component.exports